export default "__VITE_ASSET__BW7FA6qM__"